import { default as MuiDialogActions } from '@mui/material/DialogActions';

/**
 * DialogActions contains the action buttons at the bottom of a Dialog.
 *
 * Demos:
 *
 * - [Dialog — Actions](https://unify.workiva.org/components/dialog?tab=code)
 *
 * API:
 *
 * - [DialogActions API](https://unify.workiva.org/components/dialog?tab=props#dialogactions)
 */
export const DialogActions = MuiDialogActions;
export {
  type DialogActionsProps,
  dialogActionsClasses,
} from '@mui/material/DialogActions';
export * from './dialogActionsModuleAugmentation';
